import React, { useEffect } from 'react';
import AdminGroupsDashboard from '../components/admin/AdminGroupsDashboard';
import AdminAuthGate from '../components/admin/AdminAuthGate';
import { useAdminPageAuth } from '../hooks/useAdminPageAuth';
import { adminDiag } from '../utils/adminDiagnostics';

export default function AdminGroupsPage() {
  const { authReady, authTimedOut, user } = useAdminPageAuth();

  useEffect(() => {
    if (authReady && user) {
      adminDiag('admin_dashboard_rendered');
    }
  }, [authReady, user]);

  if (!authReady) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center text-gray-500 text-sm font-bold">
        Loading…
      </div>
    );
  }

  if (!user) {
    return (
      <AdminAuthGate
        title="Groups dashboard"
        authTimedOut={authTimedOut}
      />
    );
  }

  return <AdminGroupsDashboard userEmail={user.email} />;
}
